import { useMediaQuery } from 'react-responsive';

import { ShuffleIcon } from '@/components/icons';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { Badge } from '@/components/ui/daisy';
import ExamArea from '@/models/ExamArea';
import { Breakpoints } from '@/utils/Breakpoint';

type ExamBlockBadgesProps = {
  examArea: ExamArea;
  shuffleQuestions: boolean;
};

export default function ExamBlockBadges({
  examArea,
  shuffleQuestions,
}: ExamBlockBadgesProps) {
  const isXl = useMediaQuery({ minWidth: Breakpoints.xl });
  const size = isXl ? 'md' : 'xs';

  return (
    <div className="flex items-center gap-2">
      <Badge variant="soft" color="primary" size={size}>
        {examArea.area.name}
      </Badge>

      <ConditionalRenderer condition={shuffleQuestions}>
        <Badge color="success" size={size}>
          <ShuffleIcon className="w-3.5 h-3.5 text-base-content stroke-2" />
        </Badge>
      </ConditionalRenderer>
    </div>
  );
}
